export enum SettingsTypes {
	Tenant,
	Application,
}
